import { computed, inject, Injectable, Signal, signal } from '@angular/core';
import { ReadonlyRepositoryCollectionService, Result } from '@softline/core';
import { FetteinheitenRechnerRepository } from '../repositories/fetteinheiten-rechner.repository';
import { FetteinheitenRechnerZeile } from '../data/fetteinheiten-rechner-zeile';
import { QueryService, RohstoffbereitstellungQuery } from './query.service';

@Injectable()
export class FetteinheitenRechnerService extends ReadonlyRepositoryCollectionService<
  FetteinheitenRechnerZeile,
  Result<FetteinheitenRechnerZeile[]>,
  RohstoffbereitstellungQuery | undefined
> {
  readonly #queryService = inject(QueryService);

  override params: Signal<RohstoffbereitstellungQuery | undefined> = computed(() => {
    const query = this.#queryService.query();
    if (!query) return undefined;
    return query;
  });

  constructor() {
    super(inject(FetteinheitenRechnerRepository));
  }

  protected override getAll(
    result: Result<FetteinheitenRechnerZeile[]> | null | undefined
  ): FetteinheitenRechnerZeile[] {
    return result?.result ?? [];
  }
}
